const { BaseCollection } = require('./_base.collection')

/**
 * @typedef AddressModel
 * @property {string} id
 * @property {string} userId
 * @property {string=} name
 * @property {string=} email
 * @property {string=} phoneNumber
 * @property {string=} postalCode
 * @property {string=} prefecture
 * @property {string=} address
 * @property {string=} address2
 */

/**
 * @extends {BaseCollection<AddressModel>}
 */
class AddressCollection extends BaseCollection {
  constructor() {
    super('ADDRESSES')
  }

  /**
   * @param {string} userId
   * @returns {PromiseLike<AddressModel | null>}
   */
  findByUserId(userId) {
    return this.collection
      .where('userId', '==', userId)
      .limit(1)
      .get()
      .then((list) => (list.docs.length > 0 ? list.docs[0].data() : null))
  }
}

const addressCollection = new AddressCollection()

module.exports = {
  addressCollection
}
